import React, { useMemo, useState } from "react";
import { View, StyleSheet, Modal } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import { useTheme } from "../context/ThemeContext";

const NtModal = React.forwardRef(({ children, containerStyle }, ref) => {
  const [visible, setVisible] = useState(false);
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  React.useImperativeHandle(ref, () => ({
    show: () => {
      setVisible(true);
    },
    dismiss: () => {
      setVisible(false);
    },
  }));

  return (
    <View style={styles.container}>
      <Modal
        style={{}}
        animationType="fade"
        transparent={true}
        visible={visible}
        onRequestClose={() => {}}
      >
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <NtTouchableEffect
            activeOpacity={1}
            style={{
              flex: 1,
              width: "100%",
              height: "100%",
              position: "absolute",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
            onPress={() => {
              setVisible(false);
            }}
          ></NtTouchableEffect>

          <View style={[styles.modalView, containerStyle]}>{children}</View>
        </View>
      </Modal>
    </View>
  );
});

const makeStyles = (t) =>
  StyleSheet.create({
    container: {},
    modalView: {
      shadowColor: "black",
      shadowOffset: { width: 0, height: 8 },
      shadowRadius: 20,
      shadowOpacity: 0.4,
      elevation: 6,
      backgroundColor: t.surface,
      borderWidth: 1,
      borderColor: t.borderSoft,
      padding: 14,
      borderRadius: t.radiusCard,
      maxHeight: "90%",
    },
  });

export default NtModal;
